import { render, staticRenderFns } from "./CategoriesCombobox.vue?vue&type=template&id=44b635f6&scoped=true&"
import script from "./CategoriesCombobox.vue?vue&type=script&lang=js&"
export * from "./CategoriesCombobox.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesCombobox.vue?vue&type=style&index=0&id=44b635f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b635f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VChip,VCombobox,VIcon,VListItemTitle,VSubheader})
